// @flow
import React from 'react';
import Box from '@waglabs/box';
import Text from '@waglabs/text';
import Icon from '@waglabs/icon';
import Flex from '@waglabs/flex';
import type { Route } from 'NavigationTypes';
import NavigationSubItem from '../NavigationSubItem/NavigationSubItem';
import TrackableLink from '../../../Tracking/TrackableLink';

type Props = {
  index: number,
  route: {
    ...Route,
    subRoutes: Route[],
  },
  currentPathname: string,
};

type State = {
  isActive: boolean,
  activeSubNavId?: number,
};

export class NavigationItem extends React.Component<Props, State> {
  state = {
    isActive: false,
    activeSubNavId: undefined,
  }

  setIsActive = () => {
    this.setState({
      isActive: true,
    });
  }

  setIsNotActive = () => {
    this.setState({
      isActive: false,
    });
  }

  setActiveSubNavId = (id: number) => () => {
    this.setState({
      activeSubNavId: id,
    });
  }

  render() {
    const {
      index,
      route,
      currentPathname,
    } = this.props;

    const {
      isActive,
      activeSubNavId,
    } = this.state;

    return (
      <Flex
        flexDirection="column"
        onMouseEnter={this.setIsActive}
        onMouseLeave={this.setIsNotActive}
      >
        <TrackableLink
          destinationUrl={String(route.path)}
        >
          <Flex
            mr={[0, 30, 4]}
            flexDirection="row"
            alignItems="center"
            hover
          >
            {index === 0
              && (
                <Icon
                  width={25}
                  mr={2}
                  name="walker"
                  hover
                />
              )}
            <Flex
              flexDirection="column"
              justifyContent="center"
              alignItems="center"
              position="relative"
              height={35}
            >
              <Box
                display={index === 0
                  ? ['none', 'none', 'block']
                  : ['none', 'block']}
              >
                <Text
                  fontFamily="body"
                  color={index === 0 ? 'wagGreen' : 'medGray'}
                  textDecoration="none"
                  fontSize={[2, 4]}
                  m={0}
                  mb={1}
                  hover
                >
                  {route.label}
                </Text>
              </Box>
              <Box
                height={3}
                width={isActive ? 1 : 0}
                bg="wagGreen"
                position="absolute"
                right={isActive ? 'auto' : 0}
                left={isActive ? 0 : 'auto'}
                bottom={0}
                transition="0.2s linear width"
              />
            </Flex>
            {index === 1
              && (
                <Icon
                  ml={2}
                  width={15}
                  height={15}
                  mb="5px"
                  name="caratDownGray"
                />
              )}
          </Flex>
        </TrackableLink>
        {route.subRoutes
          && isActive
          && (
            <Flex
              flexDirection="column"
              position="absolute"
              bg="white"
              bottom={[-350, -348, -343, -338]}
              borderRadius="0 0 15px 15px"
              overflow="hidden"
              boxShadow="0 3px 4px 0 rgba(0,0,0,.3)"
            >
              {isActive
                && route.subRoutes.map(subRoute => (
                  <NavigationSubItem
                    currentPathname={currentPathname}
                    key={String(subRoute.id)}
                    path={subRoute.path}
                    status={subRoute.status}
                    label={subRoute.label}
                    onMouseEnter={this.setActiveSubNavId(subRoute.id)}
                    isActive={activeSubNavId === subRoute.id}
                  />
                ))}
            </Flex>
          )}
      </Flex>
    );
  }
}
